import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import DeleteUser from "./../deleteUser";
import FraudBlockListContent from "./fraudBlockListContent";
import Loading from "./../../loader/loader";
import NkHeader from "./../../../common/nkheader";
import NkTable from "./../../users/nktable";
import React from "react";

const BlockListheader = ({
  searchBy,
  handlesearchBlocklist,
  setmodal,
  modal,
  deleteLoader,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  setModalShow,
  onDelete,
  filterValues,
  blockList,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  blockListExcel,
  columns,
  columnsCsv,
  pagination,
  setFilterForm,
  setSizeShow,
  modalShow,
  resetFilter,
  handleChange,
  options,
  selectedOption,
  statusFilter,
  handleSearch,
  handleReset,
  setType,
  setIdentyId,
  type,
  identyId,
  searchblockList,
  setBlockbutton,
  blockbutton,
  searchdataLoading,
  handlesaveBlocklist,
  country,
  setCountry,
  countryList,
}) => {
  return (
    <>
      <Container fluid>
        <NkHeader title="Blacklist" />
        <FraudBlockListContent
          searchdataLoading={searchdataLoading}
          searchblockList={searchblockList}
          setType={setType}
          setBlockbutton={setBlockbutton}
          blockbutton={blockbutton}
          handlesearchBlocklist={handlesearchBlocklist}
          setIdentyId={setIdentyId}
          type={type}
          identyId={identyId}
          searchBy={searchBy}
          modal={modal}
          handlesaveBlocklist={handlesaveBlocklist}
          setmodal={setmodal}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          setSearchByValue={setSearchByValue}
          setSearchBy={setSearchBy}
          searchByValuePlaceholder={searchByValuePlaceholder}
          searchByValue={searchByValue}
          blockList={blockList}
          handleSearch={handleSearch}
          resetFilter={resetFilter}
          country={country}
          setCountry={setCountry}
          countryList={countryList}
        />

        <>
          <Row>
            <div
              className="col"
              style={{ paddingRight: "1px", paddingLeft: "1px" }}
            >
              <Card style={{ padding: "1.25rem 1.5rem" }}>
                {dataLoading ? (
                  <div style={{ textAlign: "center" }}>
                    <Loading />
                  </div>
                ) : (
                  <>
                    <NkTable
                      dataexcal
                      filename={"blocklist"}
                      data={blockList}
                      buttonRef={buttonRef}
                      type="blocklist"
                      filterdata={filterForm}
                      onExcelClciked={() => onExcelClciked(filterForm)}
                      dataEXCEL={blockListExcel}
                      columns={columns}
                      columnsCsv={columnsCsv}
                      pagination={pagination}
                      onPagechange={(page) => {
                        setFilterForm({
                          ...filterForm,
                          page: page,
                        });
                      }}
                      showSizeChanged={(pageSize) => {
                        setSizeShow(pageSize);
                        setFilterForm({
                          ...filterForm,
                        });
                      }}
                    />
                  </>
                )}
              </Card>
            </div>
          </Row>
        </>
      </Container>
      <DeleteUser
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        deleteLoader={deleteLoader}
        selectedOption={selectedOption}
        options={options}
        onDelete={onDelete}
        handleChange={handleChange}
      />
    </>
  );
};

export default BlockListheader;
